import { Box, Avatar as MuiAvatar, Typography } from '@mui/material'
import { merge } from 'lodash'
import { CircleUser } from 'lucide-react'
import { forwardRef, useEffect, useState } from 'react'
import { Link } from './Link'

export const Avatar = forwardRef(
  (
    {
      src,
      alt,
      onClick = () => {},
      sx = {},
      isActive: isActiveInitial,
      trackIsActiveInitial = false,
      disableHover = false,
      children,
      label,
      avatarProps = {
        size: 30,
      },
      typographyProps = {
        variant: 'textPrimary',
      },
      link,
      icon,
      ...rest
    },
    ref
  ) => {
    const [isActive, setIsActive] = useState(isActiveInitial)
    useEffect(() => {
      if (trackIsActiveInitial) {
        setIsActive(isActiveInitial)
      }
    }, [isActiveInitial])
    const clickable = !!link || !!onClick
    return (
      <Box
        onMouseEnter={() => {
          if (clickable) {
            setIsActive(true)
          }
        }}
        onMouseLeave={() => setIsActive(false)}
        component={link ? Link : undefined}
        to={link || ''}
        onClick={(e) => {
          e?.preventDefault()
          onClick?.()
        }}
        sx={merge(
          {
            display: 'flex',
            alignItems: 'center',
            gap: 1,
            transition: 'all 0.25s ease-in-out',
            borderRadius: 1,
            width: 'fit-content',
            '&:hover':
              clickable || !disableHover
                ? {
                    cursor: 'pointer',
                    backgroundColor: 'grey.dark',
                  }
                : {},
          },
          sx || {}
        )}
        {...rest}
      >
        <MuiAvatar
          className={isActive ? 'active' : ''}
          src={src}
          alt={alt}
          ref={ref}
          imgProps={{
            draggable: false,
          }}
          {...avatarProps}
          sx={merge(
            {
              width: avatarProps.size,
              height: avatarProps.size,
              background: 'none',
              color: (theme) => theme.palette.grey.light,
              filter: 'grayscale(100%)',
              transition: 'all 0.25s ease-in-out',
              '&:hover, &.active': !disableHover && {
                cursor: 'pointer',
                transform: 'scale(1.1)',
                filter: 'grayscale(0%)',
              },
            },
            avatarProps.sx || {}
          )}
        >
          {icon || <CircleUser strokeWidth={1} size={avatarProps.size} />}
        </MuiAvatar>
        {label && <Typography {...typographyProps}>{label}</Typography>}
      </Box>
    )
  }
)
